<template>
	<div
		class="ao-expansion-panel"
		:class="{ 'expansion-panel-active': computedShowState }"
	>

		<!-- <pre
			class="mb-2"
			style="padding: 0.5rem; background-color: #3c3b3b; color: rgb(39, 136, 18); font-size: 12px;"
		><code>{{ {
			modelValue: props.modelValue,
			showState,
			computedShowState,
		} }}</code></pre> -->

		<button
			class="expansion-activator d-flex align-center w-100 py-3 text-textSecondary700"
			@click="toggleShowContent"
		>

			<slot name="activator">

				<div
					class="expansion-title ao-p2-medium"
					:class="[
						{ 'text-uppercase': titleUppercase },
						titleClass,
					]"
				>
					<slot name="title">
						{{ title }}
					</slot>
				</div>

				<div class="expansion-icon ms-auto">
					<slot name="icon">
						<div
							class="icon-wrapper d-flex justify-center align-center"
							:class="{ 'icon-rounded': iconRounded }"
						>
							<ao-icon
								:iconName="icon"
							/>
						</div>
					</slot>
				</div>

			</slot>

		</button>

		<div
			ref="ContentElement"
			class="expansion-content"
		>
			<slot name="default">
				{{ text }}
			</slot>
		</div>

	</div>
</template>

<script setup>
import { ref, computed, watch, onMounted, nextTick } from 'vue'

const props = defineProps({

	modelValue: {
		type: Boolean,
		default: () => (null),
	},

	initialShowState: {
		// если передадите modelValue, то initialShowState будет игнорироваться
		type: Boolean,
		default: null,
	},

	title: {
		type: String,
		default: '',
	},

	icon: {
		type: String,
		default: 'arrowDown',
	},

	text: {
		type: String,
		default: '',
	},

	titleClass: {
		type: String,
		default: '',
	},

	titleUppercase: {
		type: Boolean,
		default: true,
	},

	iconRounded: {
		type: Boolean,
		default: false,
	},

})

const emit = defineEmits([
	'update:modelValue',
])

const ContentElement = ref(null)

const showState = ref(true)

const computedShowState = computed({
	get() {
		if (props.modelValue === null) {
			return showState.value
		} else {
			return props.modelValue
		}
	},
	set(value) {
		if (props.modelValue === null) {
			showState.value = value
		} else {
			emit('update:modelValue', value)
		}
	},
})

const callMaxHeight = async () => {
	await nextTick()
	if (computedShowState.value) {
		ContentElement.value.style.maxHeight = `${ContentElement.value.scrollHeight}px`
	} else {
		ContentElement.value.style.maxHeight = '0px'
	}
}

const toggleShowContent = () => {
	computedShowState.value = !computedShowState.value
}

watch(computedShowState, () => {
	callMaxHeight()
})

onMounted(() => {
	if (props.initialShowState !== null) {
		computedShowState.value = props.initialShowState
	}
	ContentElement.value.style.maxHeight = computedShowState.value ? `${ContentElement.value.scrollHeight}px` : '0px'
})

</script>

<style lang="scss">
.ao-expansion-panel {

	.icon-wrapper {
		width: 16px;
		height: 16px;
		transform: rotate(0deg);
		transition: transform ease-in 0.3s;

		&.icon-rounded {
			border-radius: 50%;
			color: rgb(var(--v-theme-primary));
			background: #d9e4ec;
		}

		.ao-icon {
			width: 10px;
			height: 10px;
			font-size: 10px;
		}

	}

	.expansion-content {
		overflow: hidden;
		transition: max-height linear 0.3s;
	}

	&.expansion-panel-active {
		.icon-wrapper {
			transform: rotate(180deg);
		}
	}

}
</style>
